module.exports = __webpack_public_path__ + "site/img/125.263eb66f.jpg";